import { createFileRoute, redirect } from "@tanstack/react-router"
import { AccountSettingsPage } from "@/pages/AccountSettingsPage"

const VALID_TABS = ["profile", "security", "notifications"] as const

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (!VALID_TABS.includes(params.tabKey as (typeof VALID_TABS)[number])) {
      throw redirect({
        to: "/account-settings/$tabKey",
        params: { tabKey: "profile" },
      })
    }
  },
  component: AccountSettingsPage,
})
